import { lazyWithRetry } from 'utils/lazyWithRetry';

const named = (importPromise, exportName) => importPromise.then(m => ({ default: m[exportName] }));

export const AsyncFastSearch = lazyWithRetry(() =>
  named(import('containers/FastSearch'), 'FastSearchContainerConnected')
);
export const AsyncRatesImport = lazyWithRetry(() =>
  named(import('containers/RatesImport'), 'RatesImportContainerConnected')
);
export const AsyncProductsImport = lazyWithRetry(() =>
  named(import('containers/ProductsImport'), 'ProductsImportContainerConnected')
);
export const AsyncStaticRatesAvailabilityImport = lazyWithRetry(() =>
  named(import('containers/StaticRatesAvailabilityImport'), 'StaticRatesAvailabilityImportContainerConnected')
);
export const AsyncOfferRouting = lazyWithRetry(() => named(import('containers/OfferRouting'), 'OfferRouting'));
export const AsyncAnnouncementsRouting = lazyWithRetry(() =>
  named(import('containers/Announcements'), 'AnnouncementsRouting')
);
export const AsyncHotelCollectionRouting = lazyWithRetry(() =>
  named(import('containers/HotelCollection/routing'), 'HotelCollectionRouting')
);
export const AsyncBookingManagerRouting = lazyWithRetry(() =>
  named(import('containers/BookingManager/routing'), 'BookingManagerRouting')
);
export const AsyncRateBreakRouting = lazyWithRetry(() =>
  named(import('containers/RateBreak/routing'), 'RateBreakRouting')
);
export const AsyncTravelCompaniesRouting = lazyWithRetry(() =>
  named(import('containers/TravelCompanies/routing'), 'TravelCompaniesRouting')
);
export const AsyncTravelAgentsRouting = lazyWithRetry(() =>
  named(import('containers/TravelAgents/routing'), 'TravelAgentsRouting')
);
export const AsyncInternalUsersRouting = lazyWithRetry(() =>
  named(import('containers/InternalUsers/routing'), 'InternalUsersRouting')
);
export const AsyncStatementRouting = lazyWithRetry(() => named(import('containers/Statement'), 'StatementRouting'));
export const AsyncBookingBuilderV1 = lazyWithRetry(() => named(import('pages/BookingBuilderV1'), 'BookingBuilderV1'));
export const AsyncBookingBuilderV3 = lazyWithRetry(() => named(import('pages/BookingBuilderV3'), 'BookingBuilderV3'));
export const AsyncProposalsRouting = lazyWithRetry(() =>
  named(import('containers/Proposals/routing'), 'ProposalsRouting')
);
export const AsyncCredentialsInfoRouting = lazyWithRetry(() =>
  named(import('containers/CredentialsInfo'), 'CredentialsInfoRouting')
);
export const AsyncDashboard = lazyWithRetry(() => named(import('pages/Dashboard/Dashboard'), 'Dashboard'));
export const AsyncLanding = lazyWithRetry(() => import('containers/Landing/Landing'));
export const AsyncInventoryWorkspacesHomepage = lazyWithRetry(() =>
  named(import('containers/InventoryWorkspacesHomepage'), 'InventoryWorkspacesHomepage')
);
export const AsyncLiveRatesRouting = lazyWithRetry(() =>
  named(import('containers/LiveRates/routing'), 'LiveRatesRouting')
);
export const AsyncCognitoCallback = lazyWithRetry(() =>
  named(import('pages/CognitoCallback/CognitoCallback'), 'CognitoCallback')
);
export const AsyncCognitoFlowError = lazyWithRetry(() =>
  named(import('pages/CognitoFlowError/CognitoFlowError'), 'CognitoFlowError')
);
export const AsyncNotFound = lazyWithRetry(() => named(import('pages/NotFound/NotFound'), 'NotFound'));
export const AsyncAncillarySuppliersRouting = lazyWithRetry(() =>
  named(import('containers/AncillarySuppliers/routing'), 'AncillarySuppliersRouting')
);
export const AsyncAncillaryActivitiesRouting = lazyWithRetry(() =>
  named(import('containers/AncillaryActivities/routing'), 'AncillaryActivitiesRouting')
);
export const AsyncAncillaryTransfersRouting = lazyWithRetry(() =>
  named(import('containers/AncillaryTransfers/routing'), 'AncillaryTransfersRouting')
);
export const AsyncAncillaryGroundServicesRouting = lazyWithRetry(() =>
  named(import('containers/AncillaryGroundServices/routing'), 'AncillaryGroundServicesRouting')
);
export const AsyncBookingConfirmationRouting = lazyWithRetry(() =>
  named(import('containers/BookingConfirmation/routing'), 'BookingConfirmationRouting')
);
export const AsyncTaskManagementRouting = lazyWithRetry(() =>
  named(import('containers/TaskManagement/routing'), 'TaskManagementRouting')
);

export const AsyncRecurringTaskManagementRouting = lazyWithRetry(() =>
  named(import('containers/TaskManagement/routing'), 'RecurringTaskManagementRouting')
);
export const AsyncGroundOperation = lazyWithRetry(() =>
  named(import('containers/GroundOperation/GroundOperation'), 'GroundOperation')
);
export const AsyncBasketRouting = lazyWithRetry(() => named(import('containers/Basket/routing'), 'BasketRouting'));
export const AsyncHotelAdminRouting = lazyWithRetry(() =>
  named(import('containers/HotelAdmin/routing'), 'HotelAdminRouting')
);
export const AsyncCRMRouting = lazyWithRetry(() => named(import('containers/CRM/routing'), 'CRMRouting'));
export const AsyncContentsAdminRouting = lazyWithRetry(() =>
  named(import('containers/ContentsAdmin/routing'), 'ContentsAdminRouting')
);
export const AsyncContentMarketingRouting = lazyWithRetry(() =>
  named(import('containers/ContentMarketing/routing'), 'ContentMarketingRoutingWithRouter')
);
export const AsyncSettings = lazyWithRetry(() => named(import('pages/Settings/Settings'), 'Settings'));
export const AsyncSharedLinkRouting = lazyWithRetry(() =>
  named(import('containers/SharedLinkPage/routing'), 'SharedLinkRouting')
);
export const AsyncOtpRouting = lazyWithRetry(() => named(import('containers/Otp/routing'), 'OtpRouting'));
export const AsyncItineraryPageRouting = lazyWithRetry(() =>
  named(import('containers/Itinerary/routing'), 'ItineraryPageRouting')
);
export const AsyncVoucherPageRouting = lazyWithRetry(() =>
  named(import('containers/Voucher/routing'), 'VoucherPageRouting')
);
export const AsyncChatPageRouting = lazyWithRetry(() => named(import('containers/Chat/routing'), 'ChatPageRouting'));
export const AsyncReviewPageRouting = lazyWithRetry(() =>
  named(import('containers/ReviewPage/routing'), 'ReviewPageRouting')
);
export const AsyncKnowledgeBaseRouting = lazyWithRetry(() =>
  named(import('containers/KnowledgeBase/routing'), 'KnowledgeBaseRouting')
);
export const AsyncVccRouting = lazyWithRetry(() => named(import('containers/Vcc'), 'VccRouting'));
export const AsyncBankTransactionsRouting = lazyWithRetry(() =>
  named(import('containers/BankTransactions/routing'), 'BankTransactionsRouting')
);
export const AsyncConversionRatesPage = lazyWithRetry(() =>
  named(import('containers/ConversionRates/ConversionRatesPage'), 'ConversionRatesPage')
);
export const AsyncPaymentMethodsPage = lazyWithRetry(() =>
  named(import('containers/PaymentMethods/PaymentMethodsPage'), 'PaymentMethodsPage')
);
export const AsyncPaymentMethodCreatePage = lazyWithRetry(() =>
  named(import('containers/PaymentMethods/PaymentMethodCreatePage'), 'PaymentMethodCreatePage')
);
export const AsyncPaymentMethodEditPage = lazyWithRetry(() =>
  named(import('containers/PaymentMethods/PaymentMethodEditPage'), 'PaymentMethodEditPage')
);
export const AsyncSuppliersReconciliationPage = lazyWithRetry(() =>
  named(import('containers/SuppliersReconciliation/SuppliersReconciliationPage'), 'SuppliersReconciliationPage')
);
export const AsyncPurchaseOrderDetailPage = lazyWithRetry(() =>
  named(import('containers/SuppliersReconciliation/PurchaseOrderDetailPage'), 'PurchaseOrderDetailPage')
);
export const AsyncInvoiceUploadsPage = lazyWithRetry(() =>
  named(import('containers/InvoiceUploads'), 'InvoiceUploadsPage')
);
export const AsyncInvoiceUploadDetailPage = lazyWithRetry(() =>
  named(import('containers/InvoiceUploads'), 'InvoiceUploadDetailPage')
);
export const AsyncInvoiceUploadEditPage = lazyWithRetry(() =>
  named(import('containers/InvoiceUploads'), 'InvoiceUploadEditPage')
);
export const AsyncPayrunsPage = lazyWithRetry(() => named(import('containers/Payruns'), 'PayrunsPage'));
export const AsyncPayrunDetailPage = lazyWithRetry(() => named(import('containers/Payruns'), 'PayrunDetailPage'));
export const AsyncPayrunSummaryPage = lazyWithRetry(() =>
  named(import('containers/Payruns/PayrunSummaryPage'), 'PayrunSummaryPage')
);
export const AsyncPaymentNotificationsPage = lazyWithRetry(() =>
  named(import('containers/Payruns/PaymentNotificationsPage'), 'PaymentNotificationsPage')
);
export const AsyncRechartsDemo = lazyWithRetry(() => named(import('pages/RechartsDemo'), 'RechartsDemo'));
